// import { InterviewFormState } from "../InterviewAssessmentForm";

// export const InitialInterviewData: any = {
//   // source: "Job Portal",
//   source: "",
//   position: "frontend developer",

//   candidateName: "rns",
//   gender: "Female",
//   dateOfBirth: "2005-05-06",
//   department: "It department",
//   Address: "new delhi, delhi",
//   permanentAddress: "rajasthan",
//   mobileNo: "9874562532",
//   maritalStatus: "Married",
//   emailId: "rns12@gmail.com",

//   langSpeak: "hindi, english",
//   langRead: "hindi, spanish",
//   langWrite: "english",

//   careerGoal: "career career",
//   strength: "abc strength",
//   weakness: "abc weakness",
//   relationShip: false,
//   applied_previously: "No",

//   current_ctc: 45235,
//   expected_ctc: 89898,
//   notice_period_days: 30,
//   convicted_in_court: "No",

//   final_hr_recommendation: "recommended",
//   grade_designation_allocated: "Associate Engineer",
//   ctc_to_be_offered: 85858,
//   onboarding_date: "2026-04-01",

//   education_details: [],
//   family_details: [],
//   employment_history: [],
//   employee_relations: [],
//   prev_applications: [],
//   references: [],
// };
export const InitialInterviewData: any = {
  source: "",
  position: "",

  candidateName: "",
  gender: "",
  dateOfBirth: "",
  department: "",
  Address: "",
  permanentAddress: "",
  mobileNo: "",
  maritalStatus: "",
  emailId: "",

  langSpeak: [],
  langRead: [],
  langWrite: [],

  careerGoal: "",
  strength: "",
  weakness: "",
  relationShip: false,
  applied_previously: false,

  current_ctc: null,
  expected_ctc: null,
  notice_period_days: null,
  convicted_in_court: "",

  final_hr_recommendation: "",
  grade_designation_allocated: "",
  ctc_to_be_offered: null,
  onboarding_date: "",

  education_details: [],
  family_details: [],
  employment_history: [],
  employee_relations: [],
  prev_applications: [],
  references: [],
};
